import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import api from "../../api/axiosConfig";
import { useAuth } from "../Authentication/AuthContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./TimeSheetTable.css";
import { parseISO } from "date-fns";
import { ProjectContext } from "../../App";
import { ToastContainer, toast } from "react-toastify";
import socket from "../../socket";

const AddTimeSheet = ({ refresh: refreshTrigger, onTimesheetAdded }) => {
  const { dialBoxopen } = useContext(ProjectContext);
  const [timesheets, setTimesheets] = useState([]);
  const { userDetails } = useAuth();
  const userId = userDetails.id;
  const [openDialog, setOpenDialog] = useState(false);
  const { projectId } = useParams();
  const [loading, setLoading] = useState(true);
  const [taskTemplate, setTaskTemplate] = useState([]);
  const [projects, setProjects] = useState([]);
  const [timesheetSettings, setTimesheetSettings] = useState([]);
  const [users, setUsers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [phases, setPhases] = useState([]);
  const [isContainsHours, setIsContainHours] = useState(false);
  const [logCategory, setLogCategories] = useState([]);
  const [selectedTaskTemplate, setSelectedTaskTemplate] = useState("");
  const [taskTemplateName, setTaskTemplateName] = useState("");
  const [selectedVariationDetails, setSelectedVariationDetails] = useState("");
  const [hours, setHours] = useState("");
  useEffect(() => {
    if (!taskTemplateName) return; // ✅ Prevents "Cannot read properties of undefined"

    let hours;
    if (taskTemplateName.includes("Design")) {
      hours = selectedVariationDetails?.design;
    } else if (taskTemplateName.includes("Detailing")) {
      hours = selectedVariationDetails?.detailing;
    }

    setHours(hours);
  }, [taskTemplateName, selectedVariationDetails]);

  useEffect(() => {
    const name = taskTemplate.find(
      (t) => Number(t.id) === Number(selectedTaskTemplate)
    );
    setTaskTemplateName(name?.name);
  }, [taskTemplate, selectedTaskTemplate]);

  const [user, setUser] = useState("");
  const [timeEntryMethod, setTimeEntryMethod] = useState("duration");
  const [durationHours, setDurationHours] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedFromTime, setSelectedFromTime] = useState(null);
  const [selectedToTime, setSelectedToTime] = useState(null);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProjectStartDate, setSelectedProjectStartDate] = useState("");
  const [selectedProjectEndDate, setSelectedProjectEndDate] = useState("");
  const [selectedPhaseStartDate, setSelectedPhaseStartDate] = useState("");
  const [selectedPhaseEndDate, setSelectedPhaseEndDate] = useState("");
  const [selectedPhase, setSelectedPhase] = useState("");
  const [selectedPhaseId, setSelectedPhaseId] = useState(null);
  const [selectedLogCategory, setSelectedLogCategory] = useState("");
  const [selectedTasks, setSelectedTasks] = useState("");
  const [selectedTasksStartDate, setSelectedTasksStartDate] = useState("");
  const [selectedTasksDueDate, setSelectedTasksDueDate] = useState("");
  const [isBillable, setIsBillable] = useState("");
  const [error, setError] = useState(null);
  const [dropdownVariationOptions, setDropdownVariationOptions] = useState([]);
  const [dropdownIssueOptions, setDropdownIssueOptions] = useState([]);
  const [selectedVariation, setSelectedVariation] = useState("");
  const [selectedIssue, setSelectedIssue] = useState("");
  useEffect(() => {
    const voDetails = dropdownVariationOptions.find(
      (v) => Number(v.id) === Number(selectedVariation)
    );
    setSelectedVariationDetails(voDetails);
  }, [dropdownVariationOptions, selectedVariation]);

  useEffect(() => {
    socket.on("variation updated", (variationId, updateFields, values) => {
      setDropdownVariationOptions((prevVariations) =>
        prevVariations.map((variation) =>
          variation.id === Number(variationId)
            ? {
                ...variation,
                ...Object.fromEntries(
                  updateFields.map((field, index) => [
                    field.replace(" = ?", ""),
                    values[index],
                  ])
                ), // Convert field-value pairs
              }
            : variation
        )
      );
    });

    return () => {
      socket.off("variation updated");
    };
  }, []);
  useEffect(() => {
    if (selectedTasks && tasks.length > 0) {
      const task = tasks.find((t) => t.id === Number(selectedTasks));

      if (task) {
        setSelectedTasksDueDate(task.due_date !== null ? task.due_date : 0);
        setSelectedTasksStartDate(
          task.start_date !== null ? task.start_date : 0
        );
      } else {
        setSelectedTasksDueDate(0); // Default value or handle as per your needs
        setSelectedTasksStartDate(0);
      }
    }
  }, [selectedTasks, tasks]);

  const onClickAddtimesheet = () => {
    setOpenDialog(true);
    document.body.classList.add("no-scroll");
  };
  const [userExistingHoursInMinutes, setUserExistingHoursInMinutes] =
    useState("");
  const userID = userDetails.id;
  useEffect(() => {
    if (selectedTasks && tasks.length > 0) {
      const task = tasks.find((t) => t.id === Number(selectedTasks));

      if (task) {
        setSelectedTasksDueDate(task.due_date !== null ? task.due_date : 0);
        setSelectedTasksStartDate(
          task.start_date !== null ? task.start_date : 0
        );
      } else {
        setSelectedTasksDueDate(0); // Default value or handle as per your needs
        setSelectedTasksStartDate(0);
      }
    }
  }, [selectedTasks, tasks]);
  function normalizePlannedHours(input) {
    // If input is a decimal (e.g., "1.5"), convert it to HH:MM format
    if (/^[0-9]+([.][0-9]+)?$/.test(input)) {
      const hours = Math.floor(parseFloat(input));
      const minutes = Math.round((parseFloat(input) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    // If input is in HH:MM format, return it directly
    if (/^[0-9]+:[0-5][0-9]$/.test(input)) {
      return input;
    }

    // If input is a whole number, treat it as hours
    if (/^[0-9]+$/.test(input)) {
      return `${parseInt(input, 10)}:00`;
    }

    // For invalid formats, return an empty string
    return "";
  }

  useEffect(() => {
    const calculateExistingHours = async (user, selectedDate) => {
      try {
        const response = await api.get(
          `/api/timesheets/${user}/${selectedDate.toLocaleDateString("en-CA")}`
        );
        const userTimesheets = response.data;
        let totalMinutes = 0;
        userTimesheets.forEach((timesheet) => {
          const [hours, minutes] = timesheet.duration.split(":").map(Number);
          if (!isNaN(hours) && !isNaN(minutes)) {
            totalMinutes += hours * 60 + minutes;
          }
        });

        let res = (8 * 60 - totalMinutes) / 60; // Convert to hours
        res = normalizePlannedHours(res);
        setUserExistingHoursInMinutes(res); // Update state once
      } catch (error) {
        console.error("Error fetching existing timesheets:", error);
      }
    };

    if (user && selectedDate !== null) {
      calculateExistingHours(user, selectedDate);
    }
  }, [user, selectedDate]);
  const onClosePopUp = () => {
    setSelectedPhase([]);
    setSelectedLogCategory([]);
    setSelectedTasks([]);
    setSelectedTaskTemplate([]);
    setIsBillable([]);
    setDurationHours([]);
    setSelectedDate(null);
    setOpenDialog(false);
    // setUser([]);
    setSelectedIssue("");
    setSelectedVariation("");
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
    document.body.classList.remove("no-scroll");
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleFromTime = (timeFrom) => {
    setSelectedFromTime(timeFrom);
  };

  const handleToTime = (timeTo) => {
    setSelectedToTime(timeTo);
  };

  // Update state when projects data is available
  useEffect(() => {
    if (projects && projects.name) {
      setSelectedProject(projects.id);
      setSelectedProjectStartDate(parseISO(projects.start_date));
      setSelectedProjectEndDate(parseISO(projects.end_date));
    }
  }, [projects]);
  //update userId for user login
  useEffect(() => {
    if (userDetails.role_name !== "Administrator") {
      setUser(userDetails.id); // Set the current user's ID in state if not admin
    }
  }, [userDetails, setUser]);

  const handleTaskTemplateChange = (event) => {
    setSelectedTaskTemplate(event.target.value);
    setSelectedTasks([]);
    setSelectedDate(null);
  };

  const handlelogcategoryChanger = (e) => {
    setSelectedLogCategory(e.target.value);
    setSelectedTaskTemplate([]);
    setSelectedTasks([]);
    setTasks([]);
    setSelectedDate(null);
    setSelectedIssue("");
    setSelectedVariation("");
  };

  const handleRadioChange = (event) => {
    setIsBillable(event.target.value);
  };

  //fetch phase changes
  const handlePhaseChange = (event) => {
    const phaseId = event.target.value;
    setSelectedPhase(phaseId);
    const selectedPhaseDetails = phases.phases.find((ph) => {
      return ph.id === Number(phaseId);
    });
    setSelectedPhaseStartDate(selectedPhaseDetails.start_date);
    setSelectedPhaseEndDate(selectedPhaseDetails.end_date);
    const phase = selectedProject?.phases?.find(
      (p) => p.id === parseInt(phaseId)
    );
    if (phase) {
      setSelectedPhaseId(phase.id);
    } else {
      setSelectedPhaseId(null);
    }
    // Clear selected task template and tasks when phase changes
    setSelectedLogCategory([]);
    setSelectedTaskTemplate("");
    setTasks([]);
  };
  //fetch users, category , tasktemplate
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, logCategories, timelogRes] = await Promise.all([
          api.get(`/api/users`),
          api.get("/api/categories"),
          api.get("/api/timesheet/settings"),
        ]);
        const activeUsers = usersRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        setTimesheetSettings(
          timelogRes.data.find((t) => t.settings === "log_period").value
        );
        setLogCategories(logCategories.data);

        if (selectedPhase.length > 0) {
          const taskTemplatesRes = await api.get(
            `/api/phase/${selectedPhase}/taskTemplates`
          );
          setTaskTemplate(taskTemplatesRes.data);
        } else {
          setTaskTemplate([]); // Clear task templates if no phase is selected
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedPhase, projectId]); // Include selectedPhase as a dependency
  function normalizePlannedHours(input) {
    // If input is a decimal (e.g., "1.5"), convert it to HH:MM format
    if (/^[0-9]+([.][0-9]+)?$/.test(input)) {
      const hours = Math.floor(parseFloat(input));
      const minutes = Math.round((parseFloat(input) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    // If input is in HH:MM format, return it directly
    if (/^[0-9]+:[0-5][0-9]$/.test(input)) {
      return input;
    }

    // If input is a whole number, treat it as hours
    if (/^[0-9]+$/.test(input)) {
      return `${parseInt(input, 10)}:00`;
    }

    // For invalid formats, return an empty string
    return "";
  }
  //fetch project details
  useEffect(() => {
    const fetchProject = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/projects/${projectId}`);
        setProjects(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      fetchProject();
    }
  }, [projectId]);

  //fetch Tasks based on task template
  useEffect(() => {
    if (selectedTaskTemplate.length > 0) {
      const fetchTasks = async () => {
        try {
          const taskUser =
            userDetails.role_name === "Administrator" ||
            userDetails.role_name === "Super Admin"
              ? user
              : userId;
          const res = await api.get(
            `/api/tasks-timesheet/${selectedTaskTemplate}/${taskUser}`
          );
          setTasks(res.data);
        } catch (error) {
          console.error(error);
        }
      };
      fetchTasks();
    }
  }, [selectedTaskTemplate, userId, user]);
  //fetch phases based on project ID
  useEffect(() => {
    const fetchPhases = async () => {
      try {
        const res = await api.get(`/api/project/${projectId}/phases`);
        setPhases(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPhases();
  }, [projectId]);

  // general || variation || issue header
  let headingText;
  switch (selectedLogCategory) {
    case "1":
      headingText = "General";
      break;
    case "2":
      headingText = "Variations";
      break;
    case "4":
      headingText = "Issues";
      break;
    default:
      headingText = "Title";
  }

  //fetch variation and issue dropdown options
  useEffect(() => {
    let fetchData;

    switch (headingText) {
      case "Variations":
        fetchData = async () => {
          try {
            const res = await api.get(`/api/phase/${selectedPhase}/variations`);
            const filterDate = res.data;
            setDropdownVariationOptions(filterDate);
          } catch (error) {
            console.error(error);
          }
        };
        break;
      case "Issues":
        fetchData = async () => {
          try {
            const res = await api.get(`/api/phase/${selectedPhase}/issues`);

            setDropdownIssueOptions(res.data);
          } catch (error) {
            console.error(error);
          }
        };
        break;
      default:
        setDropdownVariationOptions([]);
        setDropdownIssueOptions([]);
    }

    if (fetchData) {
      fetchData();
    }
  }, [headingText, selectedPhase]);
  //dropdown options for variation and issue
  const dropdownOptions =
    headingText === "Variations"
      ? dropdownVariationOptions.filter((v) => v.variation_status !== "Waiting")
      : dropdownIssueOptions;
  const selectedOption =
    headingText === "Variations" ? selectedVariation : selectedIssue;
  //add new timesheet
  const handleAddTimesheet = async () => {
    setLoading(true);
    if (
      !user ||
      !selectedDate ||
      (!selectedFromTime && timeEntryMethod === "from-to") ||
      (!selectedToTime && timeEntryMethod === "from-to") ||
      (!durationHours && timeEntryMethod === "duration") ||
      !selectedProject ||
      (durationHours === "0:00") | !selectedPhase ||
      selectedTasks.length === 0 ||
      (isBillable !== "Yes" && isBillable !== "No") ||
      (selectedLogCategory !== "1" && !(selectedVariation || selectedIssue))
    ) {
      toast.error(
        durationHours === "0:00"
          ? "Enter valid duration hours"
          : "Please fill in all required details.",
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
      setLoading(false);
      return; // Stop the function execution if any details are missing
    }

    // Step 1: Fetch existing hours for the user on the selected date
    let existingHoursInMinutes = 0;
    try {
      const response = await api.get(
        `/api/timesheets/${user}/${selectedDate.toLocaleDateString("en-CA")}`
      );
      const userTimesheets = response.data;

      // Calculate the total duration in minutes from the user's existing timesheets on this date
      userTimesheets.forEach((timesheet) => {
        const [hours, minutes] = timesheet.duration.split(":").map(Number);
        existingHoursInMinutes += hours * 60 + minutes;
      });
    } catch (error) {
      console.error("Error fetching existing timesheets:", error);
      setLoading(false);
      return;
    }

    // Step 2: Calculate the duration of the new entry
    let currentEntryDurationInMinutes = 0;
    if (timeEntryMethod === "from-to") {
      const fromTimeParts = selectedFromTime
        .toLocaleTimeString("en-CA", { hour12: false })
        .split(":")
        .map(Number);
      const toTimeParts = selectedToTime
        .toLocaleTimeString("en-CA", { hour12: false })
        .split(":")
        .map(Number);

      const fromTimeInMinutes = fromTimeParts[0] * 60 + fromTimeParts[1];
      const toTimeInMinutes = toTimeParts[0] * 60 + toTimeParts[1];

      currentEntryDurationInMinutes = toTimeInMinutes - fromTimeInMinutes;
      if (currentEntryDurationInMinutes < 0) {
        currentEntryDurationInMinutes += 24 * 60; // Adjust for overnight shifts
      }
    } else if (timeEntryMethod === "duration") {
      const [hours, minutes] = durationHours.split(":").map(Number);
      currentEntryDurationInMinutes = hours * 60 + minutes;
    }

    // Step 3: Compare the total hours (existing + current entry) with the limit of 8 hours (480 minutes)
    const totalMinutesForDay =
      existingHoursInMinutes + currentEntryDurationInMinutes;
    const totalHoursForDay = totalMinutesForDay / 60;

    if (totalHoursForDay > 8) {
      toast.error(
        `You cannot log more than 8 hours in a day. Your current total would be ${totalHoursForDay.toFixed(
          2
        )} hours.`,
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );

      setLoading(false);
      return; // Stop function if the total exceeds 8 hours
    }

    // Step 4: Proceed to add the timesheet if the total hours are <= 8
    const title = tasks.find((task) => task.id === Number(selectedTasks));
    const titleName = title ? title.phase_taskname : "";

    const adjustedTimesheet = {
      user_id: user,
      date: selectedDate.toLocaleDateString("en-CA"),
      project_id: selectedProject,
      phase_id: selectedPhase,
      log_category: selectedLogCategory,
      task_id: Number(selectedTasks),
      variation_id: selectedVariation || null,
      issue_id: selectedIssue || null,
      billable: isBillable === "Yes" ? "1" : "0",
      logtitle: titleName,
      duration: "", // Will be set below
      approvalstatus: "Pending",
      notes: notes,
    };

    if (timeEntryMethod === "from-to") {
      adjustedTimesheet.fromtime = selectedFromTime.toLocaleTimeString(
        "en-CA",
        { hour12: false }
      );
      adjustedTimesheet.totime = selectedToTime.toLocaleTimeString("en-CA", {
        hour12: false,
      });

      // Convert to hh:mm:ss format
      const hours = Math.floor(currentEntryDurationInMinutes / 60);
      const minutes = currentEntryDurationInMinutes % 60;
      const seconds = 0; // Seconds are set to 0 since we only have hours and minutes

      adjustedTimesheet.duration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    } else if (timeEntryMethod === "duration") {
      // Handle the duration input for duration method
      const [hours, minutes] = durationHours.split(":").map(Number);
      adjustedTimesheet.duration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:00`; // Store in hh:mm:ss format
    }

    // Step 5: Send the timesheet to the backend
    try {
      const url = `/api/timesheets/${userId}`;

      const response = await api.post(url, adjustedTimesheet);
      const data = response.data;

      if (onTimesheetAdded) {
        onTimesheetAdded();
      }

      const newTimesheetWithNames = {
        ...data,
        duration: adjustedTimesheet.duration, // Store the formatted duration
      };

      // Update the local state with the new timesheet
      setTimesheets((prevTimesheets) => {
        const updatedTimesheets = prevTimesheets.map((phase) =>
          phase.phaseId === adjustedTimesheet.phase_id
            ? {
                ...phase,
                timesheets: [...phase.timesheets, newTimesheetWithNames],
              }
            : phase
        );
        return updatedTimesheets;
      });
      // setOpenDialog(false);
      document.body.classList.remove("no-scroll");
    } catch (error) {
      console.error("Error adding timesheet:", error);
    } finally {
      setLoading(false); // Always stop loading, even on error
      setOpenDialog(false);
      setSelectedPhase([]);
      setSelectedLogCategory([]);
      setSelectedTasks([]);
      setSelectedTaskTemplate([]);
      setIsBillable([]);
      setDurationHours([]);
      setSelectedDate(null);
      setOpenDialog(false);
      // setUser([]);
      setUserExistingHoursInMinutes("");
      setSelectedIssue("");
      setSelectedVariation("");
      setHours("");
      setTaskTemplateName("");
      setSelectedVariationDetails([]);
      document.body.classList.remove("no-scroll");
    }
  };

  //set variation or issue details
  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setHours("");
    setTaskTemplateName("");
    setSelectedVariationDetails([]);
    setSelectedTaskTemplate("");
    if (headingText === "Variations") {
      setSelectedVariation(selectedValue);
    } else if (headingText === "Issues") {
      setSelectedIssue(selectedValue);
    }
  };

  useEffect(() => {
    if (phases?.id === Number(selectedProject)) {
      const selectedProjectData = phases;
      const overallBudgetHours = selectedProjectData?.overall_budget_hours;
      const customer = selectedProjectData?.customer_name;
      const isContainsHours =
        customer !== "MSES Group Ltd" && overallBudgetHours === "00:00";
      setIsContainHours(isContainsHours);
    }
  }, [selectedProject, phases]);

  return (
    <div>
      <div>
        <button
          className="time-log-add-btn"
          style={{
            marginTop: "0px",
            position: "relative",
            fontFamily: '"Lato", sans-serif',
          }}
          onClick={onClickAddtimesheet}
          title="Add Time Log"
        >
          Add Time Log
        </button>
      </div>

      <ToastContainer />
      {openDialog && (
        <div
          className={`timesheet-overlay-add-time-log ${
            dialBoxopen ? "open" : "close"
          }`}
          style={{ zIndex: "15" }}
        >
          <div className="add-timesheet-con">
            <div className="new-time-log-dial">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "15px",
                  marginTop: "8px",
                  fontSize: "15px",
                }}
              >
                Add Time Log
              </h3>
            </div>
            <div className="scrollable-t-content">
              <h3 className="user-name">User</h3>
              {userDetails.role_name === "Administrator" ||
              userDetails.role_name === "Super Admin" ? (
                <select
                  onChange={(e) => {
                    setUser(e.target.value);
                    setSelectedPhase([]);
                    setSelectedLogCategory([]);
                    setSelectedTasks([]);
                    setSelectedTaskTemplate([]);
                    setIsBillable([]);
                    setDurationHours([]);
                    setSelectedDate(null);
                    setSelectedIssue("");
                    setSelectedVariation("");
                    setHours("");
                    setTaskTemplateName("");
                    setSelectedVariationDetails([]);
                  }}
                  value={user || ""}
                  className="timesheet-input"
                >
                  <option value="" disabled>
                    Select User
                  </option>
                  {users
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={userDetails.name} // Automatically select the logged user's name
                  className="timesheet-input"
                  readOnly
                />
              )}
              <h3 className="user-name">Project</h3>
              <input
                type="text"
                value={projects.name}
                className="timesheet-d-input"
                readOnly
              />
              <h3 className="user-name">Phase</h3>
              <select
                className="timesheet-input"
                onChange={handlePhaseChange}
                value={selectedPhase || ""}
              >
                <option value="" disabled>
                  --Select Phase--
                </option>
                {phases?.phases?.length > 0 ? (
                  phases.phases.map((phase) => (
                    <option key={phase.id} value={phase.id}>
                      {phase.title}
                    </option>
                  ))
                ) : (
                  <option disabled>
                    No Phases Available, Contact DC to add Phase for this
                    project.
                  </option>
                )}
              </select>
              <h3 className="user-name">Log Category</h3>
              <select
                className="timesheet-input"
                onChange={handlelogcategoryChanger}
                value={selectedLogCategory || ""}
              >
                <option value="" disabled>
                  --Select Category--
                </option>
                {logCategory.map((log) => (
                  <option key={log.id} value={log.id}>
                    {log.name.charAt(0).toUpperCase() + log.name.slice(1)}{" "}
                  </option>
                ))}
              </select>

              {headingText !== "General" && headingText !== "Title" && (
                <div className="Title-container">
                  <h3 className="user-name">{headingText}</h3>
                  <select
                    onChange={handleDropdownChange}
                    value={selectedOption}
                    className="timesheet-input"
                    aria-label={`Select ${headingText}`}
                  >
                    <option value="" disabled hidden>
                      --Select {headingText}--
                    </option>
                    {dropdownOptions?.length > 0 ? (
                      dropdownOptions.map((option) =>
                        headingText === "Variations" ? (
                          <option key={option.id} value={option.id}>
                            {`${option.variationno} - ${option.name}`}
                          </option>
                        ) : headingText === "Issues" ? (
                          <option key={option.id} value={option.id}>
                            {`${option.issue_number} - ${option.name}`}
                          </option>
                        ) : null
                      )
                    ) : (
                      <option disabled>
                        No {headingText} available for this project
                      </option>
                    )}
                  </select>
                </div>
              )}
              <h3 className="user-name">Task Template</h3>
              <select
                className="timesheet-input"
                onChange={handleTaskTemplateChange}
                value={selectedTaskTemplate || ""}
              >
                <option value="" disabled>
                  --Select Task Template--
                </option>
                {taskTemplate.length > 0 ? (
                  taskTemplate.map((template) => (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    There are no Task Template available for you. Contact DC to
                    add Task Template for you.
                  </option>
                )}
              </select>
              {
                <>
                  <h3 className="user-name">Task</h3>
                  <select
                    onChange={(e) => {
                      setSelectedTasks(e.target.value);
                      setSelectedDate(null);
                    }}
                    value={selectedTasks || ""}
                    className="timesheet-input"
                  >
                    <option value="" disabled>
                      --Select Task--
                    </option>
                    {tasks.length > 0 ? (
                      tasks.map((task) => (
                        <option key={task.id} value={task.id}>
                          {task.phase_taskname}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        There are no tasks available for you. Contact DC to add
                        tasks for you.
                      </option>
                    )}
                  </select>
                </>
              }
              <h3 className="user-name">Date</h3>
              <DatePicker
                placeholderText="Select Date"
                className="timesheet-d-input"
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="dd-MM-yyyy"
                minDate={
                  timesheetSettings
                    ? new Date(
                        new Date().setDate(
                          new Date().getDate() - timesheetSettings
                        )
                      )
                    : selectedTasksStartDate ||
                      selectedPhaseStartDate ||
                      selectedProjectStartDate
                }
                maxDate={
                  selectedTasksDueDate ||
                  selectedPhaseEndDate ||
                  selectedProjectEndDate
                }
              />
              <h3 className="user-name">Time Entry Method</h3>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="timeEntryToggle"
                  className="toggle-checkbox"
                  checked={timeEntryMethod === "duration"}
                  onChange={(e) =>
                    setTimeEntryMethod(
                      e.target.checked ? "duration" : "from-to"
                    )
                  }
                />
                <label className="toggle-label" htmlFor="timeEntryToggle">
                  <span className="toggle-inner"></span>
                  <span className="toggle-switch"></span>
                </label>
              </div>

              {timeEntryMethod === "from-to" && (
                <div className="from-to-container">
                  {" "}
                  <div className="from-time-container">
                    <h3 className="from" style={{ marginTop: "-3px" }}>
                      From Time
                    </h3>
                    <DatePicker
                      className="timesheet-d-input"
                      selected={selectedFromTime}
                      onChange={handleFromTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select From Time"
                    />{" "}
                  </div>{" "}
                  <div className="to-time-container">
                    <h3 className="to">To Time</h3>
                    <DatePicker
                      className="timesheet-d-input"
                      selected={selectedToTime}
                      onChange={handleToTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select To Time"
                    />{" "}
                  </div>{" "}
                </div>
              )}
              {timeEntryMethod === "duration" && (
                <div className="duration-container">
                  <h3 className="user-name" style={{ marginTop: "5px" }}>
                    Duration (HH:MM)
                  </h3>
                  <input
                    type="text"
                    className="timesheet-d-input"
                    value={durationHours}
                    onChange={(e) => setDurationHours(e.target.value)} // Allow the user to type freely
                    onBlur={(e) =>
                      setDurationHours(normalizePlannedHours(e.target.value))
                    }
                    placeholder="Enter Duration in HH:MM format (e.g., 02:30)"
                    title="Enter duration in HH:MM format (e.g., 02:30)"
                  />
                </div>
              )}
              <h3 className="user-name">Note</h3>
              <input
                type="text"
                className="timesheet-d-input"
                maxLength={60}
                value={notes}
                onChange={(e) => setNotes(e.target.value)} // Allow the user to type freely
                placeholder="Enter Note (max 60 characters)"
              />
              <h3 className="bill">Billable?</h3>
              <div className="radio-container">
                <label htmlFor="yes" className="radio-label">
                  Yes
                </label>
                <input
                  style={{ cursor: "pointer" }}
                  type="radio"
                  id="yes"
                  name="isBillable-input"
                  value="Yes"
                  checked={isBillable === "Yes"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="no" className="radio-label">
                  No
                </label>
                <input
                  style={{ cursor: "pointer" }}
                  type="radio"
                  id="no"
                  name="isBillable-input"
                  value="No"
                  checked={isBillable === "No"}
                  onChange={handleRadioChange}
                />
                <div
                  className={
                    timeEntryMethod === "duration"
                      ? "remaining-hours"
                      : "remaining-hours-fromto"
                  }
                >
                  <p style={{ color: "black", fontSize: "12px" }}>
                    {userExistingHoursInMinutes.length !== 0 &&
                      (userExistingHoursInMinutes &&
                      userExistingHoursInMinutes !== "0:00"
                        ? `Remaining hours for the date ⌛ ${format(
                            new Date(selectedDate),
                            "dd-MM-yyyy"
                          )}: ${userExistingHoursInMinutes} Hrs.`
                        : "You have already booked 8 hours for this date.")}
                  </p>
                </div>
                <p style={{ color: "red", fontSize: "12px" }}>{error}</p>
                {isContainsHours && (
                  <p style={{ color: "Red", fontSize: "12px" }}>
                    Kindly contact DC to update the planned hours for this
                    project.
                  </p>
                )}{" "}
                <p style={{ color: "red", fontSize: "12px" }}>
                  {hours === "00:00" &&
                    "Kindly contact DC to add the planned hours for this variation."}
                </p>
              </div>
            </div>
            <div className="btn-container-add-timesheet">
              <button
                className="add-btn"
                style={{
                  backgroundColor:
                    userExistingHoursInMinutes !== "0:00" &&
                    !isContainsHours &&
                    hours !== "00:00"
                      ? "#6200ee"
                      : "grey",
                }}
                disabled={
                  isContainsHours ||
                  userExistingHoursInMinutes === "0:00" ||
                  hours === "00:00"
                }
                onClick={handleAddTimesheet}
              >
                Add
              </button>
              <button onClick={onClosePopUp} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddTimeSheet;
